const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    padding: theme.spacing(4),
    transition: 'transform .25s',
  },
  rootSuggested: {
    borderColor: theme.palette.secondary.main,
  },
  rootExpandHover: {
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  suggestedBox: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '-1rem',
    left: 0,
  },
  suggested: {
    padding: `${theme.spacing(3) / 4}px ${theme.spacing(6) / 4}px`,
    borderRadius: theme.spacing(1) / 2,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white,
    fontSize: '1rem',
  },
  name: {
    flex: '1',
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(4),
  },
  priceBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
  },
  price: {
    ...theme.typography.h1,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1) / 2,
  },
  pricePrefix: {
    color: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    marginRight: theme.spacing(1),
  },
  periodicity: {
    fontSize: '1.2rem',
    fontWeight: theme.typography.fontWeightBold,
    opacity: 0.8,
  },
  description: {
    height: '126px', // line-height * 7
    fontSize: '1rem',
    textAlign: 'center',
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(4),
    overflow: 'hidden',
    opacity: 0.8,
  },
})

export default styles
